import React from 'react'
import {
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Label,
  Spinner
} from 'reactstrap'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

class FormInputField extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      busy: false,
      errorMessage: null,
      valid: false,
      value: props.value
    }
  }

  // Update component state in order to save user's input, also reset error
  // message if any.
  handleChange(event) {
    const { target: { value } } = event
    const { onChange } = this.props

    this.setState({
      errorMessage: null,
      invalid: false,
      valid: false,
      value
    })
    onChange(event)
  }

  hideBusy() {
    this.setState({
      busy: false
    })
  }

  // Removes error message if any
  hideInvalid() {
    this.setState({
      errorMessage: null,
      invalid: false
    })
  }

  reset() {
    this.hideBusy()
    this.hideInvalid()
  }

  showAsBusy() {
    this.setState({
      busy: true
    })
  }

  // Shows the given error message or errors.required_field error message
  showAsInvalid(message = null) {
    const { value } = this.state

    this.setState({
      busy: false,
      errorMessage: message,
      invalid: true,
      value: value === null ? '' : value
    })
  }

  showAsValid() {
    this.setState({
      busy: false,
      valid: true
    })
  }

  render() {
    const {
      disabled,
      inputFormtext,
      inputId,
      inputName,
      inputPlaceholder,
      intputStyle,
      inputType,
      labelText,
      onBlur,
      t,
      withoutFormGroup
    } = this.props

    const {
      busy,
      errorMessage,
      invalid,
      valid,
      value
    } = this.state

    const content = (
      <>
        {labelText.length > 0 && (
          <Label for={inputId}>{labelText}</Label>
        )}
        <div className="position-relative">
          <Input
            className="form-control"
            disabled={disabled}
            id={inputId}
            invalid={invalid}
            name={inputName}
            onBlur={(event) => onBlur(event)}
            onChange={(event) => this.handleChange(event)}
            placeholder={inputPlaceholder}
            style={intputStyle}
            type={inputType}
            valid={valid}
            value={value}
          />
          {busy && (
            <div
              className="position-absolute input-spinner"
              style={{
                top: '50%',
                right: '10px',
                transform: 'translateY(-50%)',
                zIndex: 4,
                pointerEvents: 'none'
              }}
            >
              <Spinner size="sm" />
            </div>
          )}
          {invalid && (
            <FormFeedback tooltip>
              {errorMessage || t('errors.required_field', { ns: 'commons' })}
            </FormFeedback>
          )}
        </div>
        {inputFormtext && (
          <FormText color="muted">
            {inputFormtext}
          </FormText>
        )}
      </>
    )

    if (withoutFormGroup) return content

    return (
      <FormGroup className="position-relative">
        {content}
      </FormGroup>
    )
  }
}

FormInputField.propTypes = {
  disabled: PropTypes.bool,
  inputFormtext: PropTypes.string,
  inputId: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  inputType: PropTypes.string,
  inputPlaceholder: PropTypes.string,
  intputStyle: PropTypes.shape(),
  labelText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  t: PropTypes.func.isRequired,
  value: PropTypes.string,
  withoutFormGroup: PropTypes.bool
}

FormInputField.defaultProps = {
  disabled: false,
  inputFormtext: '',
  inputPlaceholder: '',
  inputType: 'text',
  intputStyle: {},
  labelText: '',
  onBlur: () => {},
  value: '',
  withoutFormGroup: false
}

export default withTranslation('commons', { withRef: true })(FormInputField)
